// #region Dependencias
import styled, { css } from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
export const sharedTextStyle = css`
  font-size: ${({ size = 'normal' }) =>
    size === 'small'
      ? '.75rem'
      : size === 'large'
      ? '1.25rem'
      : size === 'extralarge'
      ? '2rem'
      : '1rem'};
  font-weight: ${({ weight = 'normal' }) => weight};
  margin: 0;
  text-align: ${({ align }) => align};

  ${({ contentEditable }) =>
    contentEditable &&
    `
    &:hover {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
    }

    &:focus-visible {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
      outline: none;
    }
  `}
`

const StyledText = styled.p.attrs((props) => ({
  style: {
    color:
      props.color === 'primary'
        ? colors.primary
        : props.color === 'secondary'
          ? colors.secondary
          : props.color === 'tertiary'
            ? colors.tertiary
            : props.color === 'dark'
              ? colors.text
              : props.color,
    borderRadius: `${props.borderradius}rem`
  }
}))`
  ${sharedTextStyle}
`
// #endregion

/**
 * Componente para renderizar texto.
 *
 * @class
 * @example
 * <Text color="primary" size="small" weight="bold">Ejemplo</Text>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.color - Color del texto.
 * @param {string} [props.size="normal"] - Tamaño del texto.
 * @param {string} [props.weight="normal"] - Grosor del texto.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Text = ({ children, ...props }) => {
  return <StyledText {...props}>{children}</StyledText>
}

export default Text
